// ENUM = fonte da verdade dos eventos de analytics.
//
// Cada entrada descreve COMO o evento canônico é mapeado para cada destino:
//   - ga4:     nome do evento empurrado no dataLayer (GTM / GA4).
//   - pixel:   nome do evento Meta (fbq), ou null quando não há evento padrão na Meta.
//   - clarity: { event: bool, tags: [...] } — subset curado (não firehose).
//   - schema:  'ecommerce' | 'simple' | 'custom' (define o formato do payload no GTM).
//   - funnel_stage: estágio do funil (vira tag do Clarity quando relevante).
//
// TODOS os eventos do funil + custom-farma estão mapeados aqui, mesmo os que ainda
// não têm gatilho real no código (ver src/store/analytics/saga.js). Quando o gatilho
// existir, basta chamar track('evento', params) — nada na camada precisa mudar.

const noClarity = { event: false, tags: [] };

export const EVENTOS = {
  // ---------- Funil padrão de e-commerce ----------
  page_view: { ga4: "page_view", pixel: "PageView", schema: "simple", clarity: noClarity },

  search: { ga4: "search", pixel: "Search", schema: "simple", clarity: noClarity },

  view_item_list: {
    ga4: "view_item_list", pixel: null, schema: "ecommerce",
    clarity: noClarity, funnel_stage: "list",
  },

  select_item: {
    ga4: "select_item", pixel: null, schema: "ecommerce",
    clarity: noClarity, funnel_stage: "list",
  },

  view_item: {
    ga4: "view_item", pixel: "ViewContent", schema: "ecommerce",
    clarity: noClarity, funnel_stage: "product",
  },

  view_promotion: {
    ga4: "view_promotion", pixel: null, schema: "ecommerce", clarity: noClarity,
  },

  select_promotion: {
    ga4: "select_promotion", pixel: null, schema: "ecommerce", clarity: noClarity,
  },

  add_to_cart: {
    ga4: "add_to_cart", pixel: "AddToCart", schema: "ecommerce",
    clarity: { event: true, tags: ["funnel_stage"] }, funnel_stage: "cart",
  },

  remove_from_cart: {
    ga4: "remove_from_cart", pixel: null, schema: "ecommerce",
    clarity: noClarity, funnel_stage: "cart",
  },

  view_cart: {
    ga4: "view_cart", pixel: null, schema: "ecommerce",
    clarity: noClarity, funnel_stage: "cart",
  },

  begin_checkout: {
    ga4: "begin_checkout", pixel: "InitiateCheckout", schema: "ecommerce",
    clarity: { event: true, tags: ["funnel_stage"] }, funnel_stage: "checkout",
  },

  add_shipping_info: {
    ga4: "add_shipping_info", pixel: null, schema: "ecommerce",
    clarity: noClarity, funnel_stage: "checkout",
  },

  add_payment_info: {
    ga4: "add_payment_info", pixel: "AddPaymentInfo", schema: "ecommerce",
    clarity: { event: false, tags: ["funnel_stage", "forma_pagamento"] },
    funnel_stage: "checkout",
  },

  purchase: {
    ga4: "purchase", pixel: "Purchase", schema: "ecommerce",
    clarity: { event: true, tags: ["funnel_stage", "forma_pagamento", "tem_receita", "loja"] },
    funnel_stage: "purchase",
  },

  refund: {
    ga4: "refund", pixel: null, schema: "ecommerce", clarity: noClarity,
  },

  add_to_wishlist: {
    ga4: "add_to_wishlist", pixel: "AddToWishlist", schema: "ecommerce", clarity: noClarity,
  },

  login: { ga4: "login", pixel: null, schema: "simple", clarity: noClarity },

  sign_up: { ga4: "sign_up", pixel: "CompleteRegistration", schema: "simple", clarity: noClarity },

  generate_lead: { ga4: "generate_lead", pixel: "Lead", schema: "simple", clarity: noClarity },

  // ---------- Custom farma ----------
  upload_receita: {
    ga4: "upload_receita", pixel: null, schema: "custom",
    clarity: { event: true, tags: ["tem_receita"] },
  },

  consulta_cep: {
    ga4: "consulta_cep", pixel: null, schema: "custom", clarity: noClarity,
  },

  cep_sem_cobertura: {
    ga4: "cep_sem_cobertura", pixel: null, schema: "custom",
    clarity: { event: false, tags: ["cep_sem_cobertura"] },
  },

  selecionar_loja: {
    ga4: "selecionar_loja", pixel: null, schema: "custom",
    clarity: { event: false, tags: ["loja"] },
  },

  aplicar_cupom: {
    ga4: "aplicar_cupom", pixel: null, schema: "custom", clarity: noClarity,
  },

  cupom_invalido: {
    ga4: "cupom_invalido", pixel: null, schema: "custom", clarity: noClarity,
  },

  contato_whatsapp: {
    ga4: "contato_whatsapp", pixel: "Contact", schema: "custom", clarity: noClarity,
  },
};

export default EVENTOS;
